export default __webpack_public_path__ + "static/media/Night_Owl_Mothers_Day_Sale_Banner.b1faffe2.jpg";